"use client";

import React from "react";
import { OakFlex, OakBox } from "@oaknational/oak-components";

import { ListHeader } from "@/components";
import type { ProgrammeFields, Unit } from "@/types/ui";

type Props = {
  yearSlug: string;
  programmeUnits: Unit[][];
  programmeData: ProgrammeFields;
  subjectsUrlTemplate: string;
  headerLeftSlot?: React.ReactElement;
  children?: React.ReactElement;
};
export const UnitsListingView = ({
  programmeUnits,
  programmeData,
  yearSlug,
  subjectsUrlTemplate,
  headerLeftSlot,
  children,
}: Props) => {
  return (
    <OakFlex
      $flexDirection="column"
      $rowGap={"spacing-48"}
      $ph={["spacing-16", "spacing-32", "spacing-48"]}
      $pv={["spacing-16", "spacing-32", "spacing-48"]}
    >
      <ListHeader
        backHref={subjectsUrlTemplate.replace(":yearSlug", yearSlug)}
        tagLabel={`${programmeUnits.length} units`}
        headerLeftSlot={headerLeftSlot}
        bulletListLabels={[
          `Year ${programmeData.year}`,
          programmeData.pathway ?? undefined,
          programmeData.examboard ?? undefined,
          programmeData.tier ?? undefined,
        ].filter((l) => l !== undefined)}
        title={programmeData.subject ?? undefined}
        description={programmeData.subjectDescription}
        color={"bg-decorative3-main"}
      />
      <OakBox>{children}</OakBox>
    </OakFlex>
  );
};
